import React from 'react';
import {
  WMSTileLayer,
} from 'react-leaflet';

const initPathWMS = process.env.REACT_APP_WMS;

export default function LayerRiver() {
  return (
    <WMSTileLayer
      url={`${initPathWMS}thaiwater30/wms`}
      version="1.1.0"
      opacity={1}
      transparent
      layers="layers=thaiwater30:river_thailand"
      srs="EPSG:4326"
      format="image/png"
      tiled
    />
  );
}
